import { withInstall } from "../../utils/index"
import scPopconfirm from './component/ScPopconfirm.vue'

export const ScPopconfirm = withInstall(scPopconfirm)

export * from './component/type'